module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/100.88c05750.png";